import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { WipService } from 'app/modules/well-integrity-planning/services/wip.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlanDateAction, WIPType } from 'app/modules/well-integrity-planning/model';
import { take } from 'rxjs';
import { OtherActivity } from 'app/modules/well-integrity-planning/model/other.model';
import module from 'app/modules/well-integrity-planning/well-integrity-planning.module';

@Component({
    selector: 'app-other-activity-form',
    templateUrl: './other-activity.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./other-activity.component.scss'],
})
export class OtherActivityComponent {
    isUpdate: boolean = false;
    type: string;
    payload: OtherActivity = {
        id: '',
        activityName: '',
        activityCompletion: 0,
    };

    constructor(
        public dialogRef: MatDialogRef<OtherActivityComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { payload: OtherActivity; type: WIPType; action: PlanDateAction },
        private service: WipService
    ) {}

    ngOnInit() {
        Promise.resolve().then(() => {
            this.isUpdate = false;
            let { id, activityName, activityCompletion } = { ...this.data.payload };
            this.payload = { id, activityName, activityCompletion };
            this.type = this.data.type;
        });
    }

    save() {
        const action = this.data.action == 'create' ? this.create() : this.update();
        action.pipe(take(1)).subscribe((response) => {
            this.isUpdate = true;
            this.closeDialog();
        });
    }

    create() {
        let { activityName, activityCompletion } = { ...this.payload };
        this.payload = { activityName, activityCompletion };
        return this.service.createOtherActivity(this.payload);
    }

    update() {
        return this.service.updateOtherActivity(this.payload);
    }

    deleteRecord() {
        return this.service.deleteOtherActivity(this.payload.id).subscribe((response) => {
            this.isUpdate = true;
            this.closeDialog();
        });
    }

    closeDialog(): void {
        this.dialogRef.close(this.isUpdate);
    }
}
